<template>
  <div style="width:100%">
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" :clipped-right="$vuetify.breakpoint.lgAndUp" app :color="colores.primario" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span>GMF</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-badge color="red" overlap content="0" :value="0"><v-icon>mdi-email</v-icon></v-badge>
      </v-btn>
      <v-btn icon v-if="items.contSfcCase<= 0">
        <v-badge color="red" overlap content="0" :value="0"><v-icon>mdi-bell</v-icon></v-badge>
      </v-btn>
      <v-btn icon  v-if="items.contSfcCase>0">
        <v-menu offset-y>
          <template v-slot:activator='{ on, attrs }' >
          <v-btn icon v-bind='attrs' v-on='on'>
            <v-badge overlap  :content="items.contSfcCase" color="red" v-bind='attrs' v-on='on'><v-icon>mdi-bell</v-icon></v-badge>
          </v-btn>
          </template>
          <v-list>
            <v-container >
                <v-row v-for="(data) in this.items.sfcCase" :key="data.id" style="border: 1px solid #0072CE">
                  <v-col cols="12" style="font-size:12px" class="text-left">
                  <v-col  >
                    <span >Caso #:  {{data.codigo}} Fecha: {{data.created_at.substr(0, 10)}} {{data.original}}</span>
                  </v-col>
                  </v-col>
                </v-row>
            </v-container>
          </v-list>
        </v-menu>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator='{ on, attrs }'>
          <v-btn icon v-bind='attrs' v-on='on'><v-icon>mdi-account-circle</v-icon></v-btn>
        </template>
        <v-list>

          <v-container>
              <v-row no-gutters>
                <v-col cols="12" style="font-size:12px" class="text-center">
                  <v-icon size="70">mdi-account</v-icon>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" style="font-size:12px" class="text-center">
                  {{ session.nombres }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" style="font-size:12px" class="text-center">
                  {{ session.apellidos }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-btn @click="cerrar_session" x-small :color="colores.black" dark>CERRAR SESIÓN</v-btn>
                </v-col>
              </v-row>
          </v-container>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import recBandeja from '@/js/rec_bandeja.js'
export default {
  name: 'MenuTop',
  props: ['colores', 'session', 'items'],
  mixins: [recBandeja],
  data: () => ({
    drawer: true
  }),
  methods: {
    cerrar_session () {
      var id, identificacion, nombres, apellidos, correo, tipo, area, permisos
      id = 0
      identificacion = ''
      nombres = ''
      apellidos = ''
      correo = ''
      tipo = ''
      area = 0
      permisos = []
      // token = data.token
      this.$store.commit('setAutenticacion', false)
      this.$store.commit('setSession', { id, identificacion, nombres, apellidos, correo, tipo, area, permisos })
      // this.$store.commit('setToken', token)
      this.$router.replace({ path: '/' })
      // this.$router.replace({ path: 'bandeja?idusu=', query: { idusu: id } })
      // eslint-disable-next-line handle-callback-err
      this.$router.push('/').catch(err => {})
    }
  }
}
</script>
